import { Component, OnInit } from '@angular/core';
import { ICompany } from 'app/shared/Domains/company';
import { ConfirmationService, MessageService } from 'primeng/api';
import { AppServiceManager } from 'common/services/appServiceManager';
import { BreadcrumbService } from 'app/breadcrumb.service';
import { Title } from '@angular/platform-browser';
import { IUser } from 'app/shared/Domains/IUser';
import { AuthService } from 'common/services/auth.service';
import { Configuration } from 'config/config';
import { IEmailFields } from 'app/shared/Domains/emailFields';
import { DatePipe } from '@angular/common';
import { IBranch } from 'app/shared/Domains/branch';
import { ExportDataComponent } from 'app/members/components/export-data/export-data.component';
import { LanguageService } from 'app/LanguageService/Language.Service';
@Component({
  selector: 'app-training-attendence-report',
  templateUrl: './training-attendence-report.component.html',
  styleUrls: ['./training-attendence-report.component.css']
})
export class TrainingAttendenceReportComponent implements OnInit {
  attendecereports: any[];
  options: any[];
  company: ICompany;
  branch: IBranch;
  selectedOption: any;
  loading: boolean;
  from: any;
  visitorContact: any;
  imgPreview: boolean = false;
  imgPreviewImg: any;
  to: any;
  tagNumber: any;
  trainer: any;
  date: any;
  user: IUser;
  attendenceCount = 0;
  photo: any[] = [];
  displayPhoto: boolean = false;
  isData: boolean;
  emailConfirmationModal: boolean;
  email: IEmailFields;
  htmlToPdf: any;
  role:any;

  constructor(
    private LanguageService: LanguageService,
    private messageService: MessageService,
    private appServiceManager: AppServiceManager,
    private breadcrumbService: BreadcrumbService,
    private datePipe: DatePipe,
    public config: Configuration,
    private exportDataComponent: ExportDataComponent,
    private confirmationService: ConfirmationService
  ) {
    this.breadcrumbService.setItems([
      { label: 'Training Attendence Reports' }
    ]);
  }
  setLabel(label) {
    return this.LanguageService.GetCurrentLanguage("TrainingAttendenceReportComponent", label);
  }
  ngOnInit() {
    this.user = AuthService.getLoggedInUser();
    this.role = AuthService.getLoggedInRole();
    this.company = new ICompany();
    this.branch = new IBranch();
    this.getCompany();
    this.date = new Date();
    this.getBranch();
    this.loading = false;
    this.resetFilter();
    this.isData = false;
    this.emailConfirmationModal = false;
    this.email = new IEmailFields();
    // this.totalAttendance();
    this.options = [
      { label: 'Search All Member', value: 'AllMember' },
      { label: 'Search By Member', value: 'Member' },
    ];
    this.search();
  }

  ExportData(reports, name) {
    this.confirmationService.confirm({
      message: "Are you sure you want to Export ?",
      accept: () => {

        const transformedData = reports.map(item => ({
          Membership_No	: item?.tagNumber,
          Name: item?.name,
          Mobile: item?.contact,
          Attendance_Date: new Date(item?.start).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' }),
          Attendance_Time: new Date(item?.start).toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', hour12: true })
        }));

        const totalRecords = reports.length;

        const summaryObject = {
          Total_Count: totalRecords,
        };
        //transformedData.push(summaryObject);
        this.exportDataComponent.ExportDataReports(transformedData,summaryObject, name);
      }
    });
    // calling export comp
  }

  getCompany() {
    this.company = AuthService.getLoggedInCompanyBranch();
    let user = JSON.parse(localStorage.getItem('currentUser'));

    if(!this.company){
    this.appServiceManager.get('companies/' + user.company).subscribe((res) => {
      if (res) {
        this.company = res;
      } else {
        this.company = new ICompany();
        this.messageService.clear();
        this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Something Went Wrong' });
      }
    },
      (error) => {
        this.company = new ICompany();
        this.messageService.clear();
        this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
      });
  }
  }
  getBranch() {
    this.branch = AuthService.getLoggedInCurrentBranch();
    if(!this.branch){
    this.appServiceManager.get('branches/' + this.user.branch).subscribe((res) => {
      if (res) {
        this.branch = res;
      } else {
        this.branch = new IBranch();
        this.messageService.clear();
        this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Something Went Wrong' });
      }
    },
      (error) => {
        this.branch = new IBranch();
        this.messageService.clear();
        this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
      });
    }
  }

  search() {
    this.attendecereports = [];
    this.attendenceCount = 0;
    let fromDate = new Date(this.from);
    let toDate = new Date(this.to);
    let data = {
      from: fromDate.getFullYear() + "-" + (fromDate.getMonth() + 1) + "-" + fromDate.getDate(),
      to: toDate.getFullYear() + "-" + (toDate.getMonth() + 1) + "-" + toDate.getDate(),
      company: this.user.company,
      branch: this.user.branch
    }
    if (this.tagNumber && this.tagNumber != '') {
      data["query"] = this.tagNumber.toString();
    }
    this.loading = true;
    this.appServiceManager.post('trainingAttendance/company/' + this.user.company + '/branch/' + this.user.branch + '/trainingAttendenceReport', data).subscribe((res) => {
      if (res.length > 0) {
        //let reports = res.filter(x => x.attendence.length > 0);
        let reports = res;
        if (reports.length > 0) {
          this.isData = true;
          this.attendecereports = res;
          this.attendenceCount = res.length;
        } else {
          this.isData = false;
        }
        // res.map(x => {
        //   if (x.attendence.length != 0) {
        //     this.isData = true;
        //   } else {
        //     this.isData = false;
        //   }
        // })
        // this.attendecereports = res;
        // this.attendecereports = this.attendecereports.sort((a, b) => { return <any>new Date(b.start) - <any>new Date(a.start) });
      } else {
        this.messageService.clear();
        this.messageService.add({ severity: 'info', summary: 'Info Message', detail: "Record not found" });
      }
      this.loading = false;
    },
      (error) => {
        this.loading = false;
        this.messageService.clear();
        this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
      });
  }

  dropdownChange() {
    this.tagNumber = "";
    this.visitorContact = "";
    this.trainer = "";
  }
  resetFilter() {
    this.attendecereports = [];
    this.selectedOption = 'AllMember';
    this.tagNumber = "";
    this.imgPreview = false;
    this.imgPreviewImg = "";
    var date = new Date();
    this.from = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    this.to = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    this.search();
  }

  openPhoto(imgUri, gender) {
    this.imgPreview = true;
    // Check if imgUri is empty or null
    if (!imgUri) {
      // Handle the case when imgUri is empty or null
      if(gender == 'F')
      this.imgPreviewImg = 'avatarGirlImage.png';

    } else {

      const isGirlAvatar = imgUri === 'avatarGirlImage.png';

      if (isGirlAvatar) {
        this.imgPreviewImg = 'avatarGirlImage.png';
      } else {
        // Handle other images
        this.imgPreviewImg = imgUri;
      }
    }
  }
  closePhotoPreview() {
    this.imgPreview = false;
    this.imgPreviewImg = "";
  }

  validateData(data) {
    if (data.search === "Member") {
      if (data.Member && data.Member !== 0) {
        return true;
      } else {
        return false;
      }
    }
    else if (data.search === "AllMember") {
      return 4;
    }
    else {
      return false;
    }
  }

  // totalAttendance() {
  //   for (let i = 0; i <= this.attendecereports.length; i++) {
  //     this.count = this.count + this.attendecereports[i].attendence.length;
  //   return this.count;
  // }

  printAllInvoice(): void {
    let printContents, popupWin;
    let currentDate=new Date();
    this.branch.name= "Trainers Attendence - "+this.branch.name+ " - " + currentDate.getDate()+ "/" + (currentDate.getMonth() + 1) + "/" + currentDate.getFullYear();
    printContents = document.getElementById('allInvoice').innerHTML;
    popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
    popupWin.document.open();
    popupWin.document.write(`
    <html>
    <head>
    <title>${this.branch.name}</title>
        <style>
            .invoice-box {
                max-width: 800px;
                margin: auto;
                padding: 30px;
                border: 1px solid #eee;
                box-shadow: 0 0 10px rgba(0, 0, 0, 0.15);
                font-size: 16px;
                line-height: 24px;
                font-family: "Helvetica Neue", "Helvetica", Helvetica, Arial, sans-serif;
                color: #555;
            }

            .invoice-box table {
                width: 100%;
                line-height: inherit;

            }

            .invoice-box table td {
                padding: 5px;
                vertical-align: top;
            }

            .invoice-box table tr td:nth-child(n + 2) {
                text-align: center;
            }

            .invoice-box table tr.top table td {
                padding-bottom: 20px;
            }

            .invoice-box table tr.top table td.title {
                font-size: 45px;
                line-height: 45px;
                color: #333;
            }

            .invoice-box table tr.information table td {
                padding-bottom: 40px;
            }

            .invoice-box table tr.heading td {
                background: #eee;
                border-bottom: 1px solid #ddd;
                font-weight: bold;
                text-align:center;
            }

            .invoice-box table tr.details td {
                padding-bottom: 20px;
            }

            .invoice-box table tr.item td {
                border-bottom: 1px solid #977c7c;
            }
            .invoice-box table tr.item.last td {
                border-bottom: none;
            }
            .invoice-box table tr.item input {
                padding-left: 5px;
            }
            .invoice-box table tr.item td:first-child input {
                margin-left: -5px;
                width: 100%;
            }
            .invoice-box table tr.total td:nth-child(2) {
                border-top: 2px solid #eee;
                font-weight: bold;
            }
            .invoice-box input[type="number"] {
                width: 60px;
            }
            @media only screen and (max-width: 600px) {
                .invoice-box table tr.top table td {
                    width: 100%;
                    display: block;
                    text-align: center;
                }

                .invoice-box table tr.information table td {
                    width: 100%;
                    display: block;
                    text-align: center;
                }
            }
            .rtl {
                direction: rtl;
                font-family: Tahoma, "Helvetica Neue", "Helvetica", Helvetica, Arial,
                    sans-serif;
            }
            .rtl table {
                text-align: right;
            }
            .rtl table tr td:nth-child(2) {
                text-align: left;
            }
        </style>
    </head>
    <body>${printContents}</body>
    </html>
    `
    );
  }

  getHtml() {
    let printContents;
    printContents = document.getElementById('allInvoice').innerHTML;
    let htmlToPdf = `<html>
    <head>
        <title>Gym Invoice</title>
        <style>
            .invoice-box {
                max-width: 800px;
                margin: auto;
                padding: 30px;
                border: 1px solid #eee;
                box-shadow: 0 0 10px rgba(0, 0, 0, 0.15);
                font-size: 16px;
                line-height: 24px;
                font-family: "Helvetica Neue", "Helvetica", Helvetica, Arial, sans-serif;
                color: #555;
            }

            .invoice-box table {
                width: 100%;
                line-height: inherit;
                text-align: left;
            }

            .invoice-box table td {
                padding: 5px;
                vertical-align: top;
            }

            .invoice-box table tr td:nth-child(n + 2) {
                text-align: right;
            }

            .invoice-box table tr.top table td {
                padding-bottom: 20px;
            }

            .invoice-box table tr.top table td.title {
                font-size: 45px;
                line-height: 45px;
                color: #333;
            }

            .invoice-box table tr.information table td {
                padding-bottom: 40px;
            }

            .invoice-box table tr.heading td {
                background: #eee;
                border-bottom: 1px solid #ddd;
                font-weight: bold;
            }

            .invoice-box table tr.details td {
                padding-bottom: 20px;
            }

            .invoice-box table tr.item td {
                border-bottom: 1px solid #eee;
            }
            .invoice-box table tr.item.last td {
                border-bottom: none;
            }
            .invoice-box table tr.item input {
                padding-left: 5px;
            }
            .invoice-box table tr.item td:first-child input {
                margin-left: -5px;
                width: 100%;
            }
            .invoice-box table tr.total td:nth-child(2) {
                border-top: 2px solid #eee;
                font-weight: bold;
            }
            .invoice-box input[type="number"] {
                width: 60px;
            }
            @media only screen and (max-width: 600px) {
                .invoice-box table tr.top table td {
                    width: 100%;
                    display: block;
                    text-align: center;
                }

                .invoice-box table tr.information table td {
                    width: 100%;
                    display: block;
                    text-align: center;
                }
            }
            .rtl {
                direction: rtl;
                font-family: Tahoma, "Helvetica Neue", "Helvetica", Helvetica, Arial,
                    sans-serif;
            }
            .rtl table {
                text-align: right;
            }
            .rtl table tr td:nth-child(2) {
                text-align: left;
            }
        </style>
    </head>
    <body>${printContents}</body>
    </html>`

    return htmlToPdf;
  }

  // sendEmailAsPdf() {
  //   let htmlToPdf = this.getHtml()
  //   this.loading = true;

  //   this.appServiceManager.post('customers/sendEmailWhileInvoicePrint',
  //     {
  //       data: htmlToPdf,
  //       from: new Date(this.from),
  //       to: new Date(this.to),
  //       type: 'Training-Attendance ',
  //       name: 'Report'
  //     }).subscribe((res) => {
  //       this.loading = false;
  //       this.messageService.clear();
  //       this.messageService.add({ severity: 'success', summary: 'Success Message', detail: "Attachment Sent Successfully!" });
  //     },
  //       (error) => {
  //         this.loading = false
  //         this.messageService.clear();
  //         this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
  //       }
  //     )
  // }

  closeEmailComfirmationModal() {
    this.emailConfirmationModal = false;
  }
  sendingBackBranchOwnerMail($event) {
    this.email.to = $event;
  }
  showEmailConfirmationModal() {
    this.htmlToPdf = this.getHtml()
    this.emailConfirmationModal = true;
    this.email.body = '<p><strong>Dear User</strong>,</p><p>Following is an attachment of training attendance report of your<em> Gym </em>:</p>';

    if (new Date(this.to).toLocaleDateString() == new Date(this.from).toLocaleDateString()) {
      this.email.subject = this.branch.name + ' | ' + 'Training Attendance Report' + ' | ' + this.datePipe.transform(new Date(this.to), 'dd-MMM-yy');
    } else {
      this.email.subject = this.branch.name + ' | ' + 'Training Attendance Report' + ' | ' + 'From: ' + this.datePipe.transform(new Date(this.from), 'dd-MMM-yy') + ' - To: ' + this.datePipe.transform(new Date(this.to), 'dd-MMM-yy');
    }
  }

  calenderDateChange() {
    this.isData = false;
  }

}
